import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import axios from 'axios';
import { getRole } from '../../utils/authUtils';

const PageContainer = styled.div`
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
`;

const Card = styled.div`
  max-width: 480px;
  width: 100%;
  background-color: white;
  padding: 2rem;
  border-radius: 0px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  text-align: center;
`;

const SuccessMessage = styled.div`
  background-color: #d4edda;
  color: #155724;
  padding: 1rem;
`;

const ErrorMessage = styled.div`
  background-color: #f8d7da;
  color: #721c24;
  padding: 1rem;
`;

const VerifyEmail = () => {
  const intl = useIntl();
  const t = (id, defaultMessage) => intl.formatMessage({ id, defaultMessage });
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const run = async () => {
      if (!token) {
        setStatus('error');
        return;
      }
      try {
        // A link from a verification mail (account.EmailVerificationController): the answer is
        // {"message":"Email verified"} or, for an unknown, expired and already-used link alike,
        // a 400 whose body says no more than the page's own copy does - so it is not shown.
        // Nothing is registered by opening this link any more: a signup completes its event
        // registration server-side (P12).
        await axios.get(`${apiUrl}/api/public/email-verification/${encodeURIComponent(token)}`);
        setStatus('success');
      } catch (err) {
        setStatus('error');
      }
    };
    run();
  }, [token]);

  return (
    <PageContainer>
      <Card>
        {status === 'checking' && <p>{t('verify.checking', 'Verifying your email…')}</p>}
        {status === 'success' && (
          <SuccessMessage>
            <p>{t('verify.success', 'Your email has been verified.')}</p>
            <p><Link to={getRole() ? '/profile' : '/login'}>{getRole() ? t('nav.myProfile', 'Go to my profile') : t('auth.signIn', 'Sign in')}</Link></p>
          </SuccessMessage>
        )}
        {status === 'error' && (
          <ErrorMessage>
            <p>{t('verify.error', 'This verification link is invalid or has expired.')}</p>
          </ErrorMessage>
        )}
      </Card>
    </PageContainer>
  );
};

export default VerifyEmail;
